/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React, { useEffect, useState } from "react";
// Redux Toolkit
import { useDispatch } from "react-redux";
// actions
import { getListing } from "../../../actions/index";
import { motion } from "framer-motion";
// Material UI components
import CircularProgress from "@mui/material/CircularProgress";
// Custom components
import ProjectListingItem from "../listing/ProjectListingItem";
import EmptyListing from "../../../shared-components/crud/listing/EmptyListing";

function ProjectsList(props) {
  const [projects, setProjects] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // dispatch
  const dispatch = useDispatch();
  // fetch projects
  const fetchProjects = async () => {
    try {
      const response = await dispatch(getListing('projects')()).unwrap();
      setProjects(response);
    } catch (err) {
      console.log(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  // get data from API on page load
  useEffect(() => {
    fetchProjects();
  }, [dispatch]);
  // 
  if (!projects || loading) {
    return (
      <CircularProgress />
    )
  }

  // check if the listing returns any results
  if (projects.length === 0) {
    return (
      <EmptyListing resource="projects" />
    );
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
      {projects.map((project) => (
        <ProjectListingItem key={project.id} project={project} />
      ))}
    </motion.div>
  );
}

export default ProjectsList;
